import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';

import login from './login';

const rootReducer = (history) => (state, action) => {
  const { routerReducer, } =
      createReduxHistoryContext({ history: history, });
  var appReducer = combineReducers({
    router: routerReducer,
    login: login,
  });
  return appReducer(state, action);
};

export default rootReducer;
